import { createBox } from '@dessert-box/react';
import { sprinkles } from '@mutiny-pkg/dumpster-ui/theme/sprinkles.css';

export const Box = createBox({
  atoms: sprinkles,
});
